import * as React from 'react';

import {
  RichTextEditorActionContext,
  RichTextEditorValueContext,
} from './context';
import { useRichTextEditorAction, useRichTextEditorValue } from './hook';
import { initialState } from './initial';
import { reducer } from './reducer';

const RichTextEditorContext = ({
  children,
  ...props
}: React.PropsWithChildren<typeof initialState>) => {
  const [state, dispatch] = React.useReducer(reducer, {
    ...initialState,
    ...props,
  });
  return (
    <RichTextEditorValueContext.Provider value={state}>
      <RichTextEditorActionContext.Provider value={dispatch}>
        {children}
      </RichTextEditorActionContext.Provider>
    </RichTextEditorValueContext.Provider>
  );
};

export {
  RichTextEditorContext,
  useRichTextEditorAction,
  useRichTextEditorValue,
};
